import React, { useState, useRef, useEffect } from "react";
import { Button, Menu, MenuItem } from "@material-ui/core";
import { IconDownArrow } from "@/components/Icon";

const DropdownButton = ({ title, menu = [], width, height, paperAutoWidth }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuWidth, setMenuWidth] = useState(null);
  const [buttonHeight, setButtonHeight] = useState(35);
  const buttonRef = useRef(null);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (buttonRef.current) {
      setMenuWidth(buttonRef.current.offsetWidth);
      setButtonHeight(buttonRef.current.offsetHeight);
    }
  }, [anchorEl]);

  return (
    <div>
      <Button
        ref={buttonRef}
        variant="contained"
        color="primary"
        onClick={handleClick}
        style={{ width, height }}
      >
        {title}
        <IconDownArrow size={8} style={{ marginLeft: 10 }} />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transformOrigin={{
          vertical: -(buttonHeight + 12)
        }}
        PaperProps={{
          style: {
            width: paperAutoWidth? "auto": menuWidth ? `${menuWidth}px` : "auto"
          }
        }}
      >
        {menu.map(menuItem => {
          const { onClick, key, name, Icon, iconProps={} } = menuItem;
          return (
            <MenuItem
              onClick={() => {
                onClick();
                setAnchorEl(null);
              }}
              key={key}
            >
              {name}
              {!!Icon && <Icon {...iconProps} />}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default DropdownButton;
